var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductLogoIconSmsMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Product logo / Logo / SMS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product-logo-/-Logo-/-SMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8197124,18.7503565 L20.374,15.09 L1.91641904,15.0903478 C0.858010028,15.0903478 -9.28727684e-16,14.2323378 0,13.1739288 L0,1.91641904 C-3.51662325e-16,0.858010028 0.858010028,-5.09906832e-14 1.91641904,-5.09630652e-14 L22.9032934,-5.09630652e-14 C23.9617024,-4.90553351e-14 24.8197124,0.858010028 24.8197124,1.91641904 L24.8197124,18.7503565 Z",
    id: "Combined-Shape",
    fill: "#0042E4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF4E61",
    cx: 4.31829456,
    cy: 21.5887523,
    r: 4.31829456
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogoIconSmsMarketing);
export default __webpack_public_path__ + "static/media/product-logo-icon-sms-marketing.e519d40ec37f1db6851314ced20daa58.svg";
export { ForwardRef as ReactComponent };